import axios from 'axios';
import config from './Config';

const instance = axios.create({
  baseURL: config.getHost(),
  timeout: 600000,
});

instance.interceptors.request.use(
  async reqConfig => {

    const accessToken = JSON.parse(localStorage.getItem("authUser"))
      ? JSON.parse(localStorage.getItem("authUser")).key
      : "";

    let headers;
    const accept = reqConfig.headers['Accept'] !== undefined ? reqConfig.headers['Accept'] : '*/*';

    if (accessToken) {
      headers = {
        'Authorization': `token ${accessToken}`,
        'Accept': accept
      };
    } else {
      headers = {
        'Accept': accept
      };
    }
    return { ...reqConfig, headers };
  },
  error => {
    return Promise.reject(error);
  }
);

export default instance;